import { GuidePage } from "./GuidePage";

const Guide = () => {
	return <GuidePage />;
};
export default Guide;
